

















import Vue from "vue";
import { mapState } from "vuex";
import { IState } from "@/store";
import { Component } from "vue-property-decorator";
import { IAccount } from "@/models/accounts";

@Component({
  computed: {
    ...mapState({
      accounts: (state: IState) => state.auth.client.accounts,
      accountId: (state: IState) => state.auth.client.accountId
    })
  }
})
export default class SelectAccountList extends Vue {
  public accountId!: IAccount["id"];
  public selectAccount(accountId: IAccount["id"]) {
    this.$emit("selected", accountId);
  }
}
